export { default } from './PageAttributes.vue'
